import { gql } from '@apollo/client';

const GET_ERROR = gql`
  query GetError {
    showErrorModal @client
    errorData @client
  }
`;

const navigationOperations = {
  GET_ERROR,
};

export default navigationOperations;
